// @flow
import React from 'react'
import glamorous, { Nav } from 'glamorous'
import { colors, typography, padding, margin, breakpoint } from 'style'

const FilterButton = glamorous.button(
  {
    ...typography.nav,
    ...padding(3),
    ':hover': {
      color: colors.secondary,
    },
    ':focus': {
      color: colors.secondary,
      outline: 0,
    },
  },
  ({ active }) => ({
    color: active && colors.secondary,
  }),
)

type Props = {
  setFilter: string => void,
  activeFilter: string,
  filters: Array<string>,
}

const FilterGroup = ({ setFilter, activeFilter, filters = [] }: Props) => (
  <Nav
    css={{
      ...margin.top(3),
      ...breakpoint.small({ display: 'flex', justifyContent: 'center' }),
    }}
  >
    <FilterButton active={activeFilter === '*'} onClick={() => setFilter('*')}>
      All
    </FilterButton>
    {filters.map(filter => (
      <FilterButton
        key={filter}
        active={activeFilter === filter.toLowerCase()}
        onClick={() => setFilter(filter.toLowerCase())}
      >
        {filter}
      </FilterButton>
    ))}
  </Nav>
)

export default FilterGroup



// WEBPACK FOOTER //
// ./src/components/FilterGroup.js